import OfferBadge from './OfferBadge';
import OfferLabel from './OfferLabel';
import Watchers from './Watchers';
import AppliedOfferToast from './AppliedOfferToast';

export default {
  OfferLabel,
  OfferBadge,
  Watchers,
  AppliedOfferToast,
};
